//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SubscribeHeroBanner',
  props: {
    showBgProductCards: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      imageBaseUrl: 'https://static.moele.me/img/channels2022/subscription/elements230321',
    };
  },
  computed: {
    productsImageUrl() {
      return `${this.imageBaseUrl}/product-feed.png?auto=format&w=4152`;
    },
  },
};
